/* eslint max-classes-per-file: 0 */

import {
  RoadmapBaseEvent as Data,
  RoadmapBaseEventCollection as Collection,
} from '@/typings/api/RoadmapBaseEvent'
import { RoadmapBaseEventsApi as Api } from '@/api/resources'

import { Fabric } from '@/store/createCrudModule'


const { TransformerParams, Adapter } = Fabric<Data, Collection>()

export class RoadmapBaseEventsTransformerParams extends TransformerParams {
  protected defaultParams = ['roadmap_id', 'direction_id'];
}

export class RoadmapBaseEventsAdapter extends Adapter<Api> {
  public readonly api = new Api();

  public readonly transformerParams = new RoadmapBaseEventsTransformerParams();
}
